import React, { useEffect, useState } from "react";
import { FaCalendarCheck, FaChartLine, FaUsers, FaUserTie } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MdDeliveryDining } from "react-icons/md";

function Dashboard() {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const [dateRange, setDateRange] = useState(() => sessionStorage.getItem('selectedDateRange') || 'Today');
    const [customStart, setCustomStart] = useState(() => sessionStorage.getItem('customStart') || '');
    const [customEnd, setCustomEnd] = useState(() => sessionStorage.getItem('customEnd') || '');

    const [data, setData] = useState({});
    const [maxCountValue, setMaxCountValue] = useState("100");
    const [maxSaleValue, setMaxSaleValue] = useState("100");
    const [avgOrder, setAvgOrder] = useState(0);
    const [avgSale, setAvgSale] = useState(0);
    const fetchData = async (startDate, endDate) => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const payload = {
                startTimestamp: new Date(startDate).getTime(),
                endTimestamp: new Date(endDate).getTime()
            };
            const res = await fetch(`${BASE_URL}/admin/v1/dashboard/salesAndOrderStats`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                const chartData = getRes.responsePacket.orderMonthWiseChartData;
                const totalOrder = chartData.reduce((sum, val) => sum + (Number(val.orderCount) || 0), 0);
                const totalSale = chartData.reduce((sum, val) => sum + (Number(val.totalSales) || 0), 0);
                const len = chartData.length || 1;
                setAvgOrder((totalOrder / len).toFixed(2));
                setAvgSale((totalSale / len).toFixed(2));

                setData(getRes.responsePacket);
                setMaxCountValue(Math.max(...chartData.map((itm) => itm.orderCount)));
                setMaxSaleValue(Math.max(...chartData.map((itm) => itm.totalSales)));
            }

        } catch (e) {
            console.log(e, "error in api");
        }
    };
    useEffect(() => {
        if (customStart && customEnd) {
            const startDate = new Date(customStart).getTime();
            const endDate = new Date(customEnd).getTime();
            fetchData(startDate, endDate);
        }
    }, [customStart, customEnd]);

    const handleDateChange = (e, type) => {
        const date = e.target.value;
        if (type === 'start') {
            setCustomStart(date);
            sessionStorage.setItem('customStart', date);
            if (customEnd && new Date(customEnd) < new Date(date)) {
                setCustomEnd('');
                sessionStorage.removeItem('customEnd');
            }
        } else {
            setCustomEnd(date);
            sessionStorage.setItem('customEnd', date);
        }
    };
    const handleDateRange = (e) => {
        setDateRange(e);
        sessionStorage.setItem('selectedDateRange', e);
        setCustomEnd('');
        setCustomStart("");
        sessionStorage.removeItem('customEnd');
        sessionStorage.removeItem('customStart');
    };

    useEffect(() => {
        const endDate = new Date(); // today
        let startDate;
        if (dateRange === "7-Days") {
            startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
            fetchData(startDate, endDate);
            sessionStorage.removeItem("customStart");
            sessionStorage.removeItem("customEnd");
        } else if (dateRange === "15-Days") {
            startDate = new Date(endDate.getTime() - 15 * 24 * 60 * 60 * 1000);
            fetchData(startDate, endDate);
            sessionStorage.removeItem("customStart");
            sessionStorage.removeItem("customEnd");
        } else if (dateRange === "Today") {
            startDate = new Date(endDate);
            startDate.setHours(0, 0, 0, 0);
            fetchData(startDate, endDate);
            sessionStorage.removeItem("customStart");
            sessionStorage.removeItem("customEnd");
        }
    }, [dateRange]);


    const redirectTo = useNavigate();
    const navigate = (nav) => {
        redirectTo(`/admin/${nav}`);
    };

    return (
        <>
            <div className="deshbord">
                <div className="row">
                    <div className="deshbord-textt" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="" style={{ width: "50%" }}>
                            <div className="text-a">
                                <h1>Sales Overview</h1>
                            </div>
                            <div className="text-b">
                                <p>Welcome to Books24 Dashboard Template</p>
                            </div>
                        </div>

                        <div className="select-input">
                            <div className="select-input-container">
                                {dateRange === "Custom" && (
                                    <div className="custom-dates">
                                        <div className="input-desh">
                                            <label htmlFor="startDate">Start Date</label>
                                            <input
                                                id="startDate"
                                                type="date"
                                                value={customStart}
                                                onChange={(e) => handleDateChange(e, "start")}
                                                placeholder="Start Date"
                                                max={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                        <div className="input-desh">
                                            <label htmlFor="endDate">End Date</label>
                                            <input
                                                id="endDate"
                                                type="date"
                                                value={customEnd}
                                                onChange={(e) => handleDateChange(e, "end")}
                                                placeholder="End Date"
                                                max={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="select-wrapper">
                                    <select
                                        id="range"
                                        value={dateRange}
                                        onChange={(e) => handleDateRange(e.target.value)}
                                    >
                                        <option disabled value>Select Date</option>
                                        <option value="Today">Today</option>
                                        <option value="7-Days">7 Days</option>
                                        <option value="15-Days">15 Days</option>
                                        <option value="Custom">Custom</option>
                                    </select>
                                </div>
                            </div>
                        </div>


                    </div>
                    <hr />

                    {/* Bar Chart */}



                    <div className="dashboard-container-a">
                        <div className="stat-box light-blue" onClick={() => navigate("orderHistory")}>
                            <div className="icon-box blue">
                                <FaCalendarCheck />
                            </div>
                            <div className="stat-content">
                                <h2>{data.totalOrder}</h2>
                                <p>Total Order</p>
                            </div>
                        </div>

                        <div className="stat-box light-yellow" onClick={() => navigate("cart")}>
                            <div className="icon-box yellow">
                                <FaUsers />
                            </div>
                            <div className="stat-content">
                                <h2>{data.totalCart}</h2>
                                <p>Total Cart</p>
                            </div>
                        </div>

                        <div className="stat-box light-orange" >
                            <div className="icon-box orange">
                                <FaChartLine />
                            </div>
                            <div className="stat-content">
                                <h2>₹ {data.totalSale}</h2>
                                <p>Total Sales</p>
                            </div>
                        </div>

                        <div className="stat-box light-green" onClick={() => navigate("customer")}>
                            <div className="icon-box green">
                                <FaUserTie />
                            </div>
                            <div className="stat-content">
                                <h2>{data.customerCount}</h2>
                                <p>Customers</p>
                            </div>
                        </div>
                        <div className="stat-box light-orange" onClick={() => navigate("order")}>
                            <div className="icon-box orange">
                                <MdDeliveryDining />
                            </div>
                            <div className="stat-content">
                                <h2>{data.liveOrderCount}</h2>
                                <p>Live Orders</p>
                            </div>
                        </div>
                    </div>
                    <div className="barChart-Container">
                        <div className="Inner-container">
                            <h3>Average Order</h3>
                            <p className="value">{avgOrder}</p>
                            {/* <p className="growth">↑ 4.63% vs. last week</p> */}
                            <div className="BarChart">
                                {data?.orderMonthWiseChartData?.map((value) => (
                                    <div
                                        className="Chart"
                                        key={value.month}
                                        style={{
                                            height: `${(value.orderCount / maxCountValue) * 100}%`,
                                            width: "40px",
                                        }}
                                        title={value.orderCount}
                                    >
                                        <span>{value.orderCount}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="month-container">
                                {data?.orderMonthWiseChartData?.map((month, index) => (
                                    <div className="month" key={index}>
                                        <span>{month.monthName}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="Inner-container">
                            <h3>Average Sale</h3>
                            <p className="value">{avgSale}</p>
                            {/* <p className="growth">↑ 4.63% vs. last week</p> */}
                            <div className="BarChart">
                                {data?.orderMonthWiseChartData?.map((value) => (
                                    <div
                                        className="Chart"
                                        key={value.month}
                                        style={{
                                            height: `${(value.totalSales / maxSaleValue) * 100}%`,
                                            width: "40px",
                                        }}
                                        title={value.totalSales}
                                    >
                                        <span>{value.totalSales}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="month-container">
                                {data?.orderMonthWiseChartData?.map((month, index) => (
                                    <div className="month" key={index}>
                                        <span>{month.monthName}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
export default Dashboard;